// extracted by mini-css-extract-plugin
module.exports = {"glide-wrapper":"glide-m__glide-wrapper__3hnia"};